module.exports = "fragment Notification on StoreNotificationType{id message created title toStore{id prologueId}createdBy{id firstName}}"